import NotFound404 from 'components/NotFound404/NotFound404';

const ErrorRoutes = {
  path: '*',
  element: <NotFound404 />,
};

export default ErrorRoutes;
